
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import { EventLinkInfo, PaginatedEventLinkInfo } from "@/store/event-links/types";
import GenericTable, { TableHeader } from "../table/generic-table.vue";
import { PaginatedSearchQueryParams } from "@/store/types";
import { Getter } from "vuex-class";
import { UserPermissions } from "@/store/types";
import router from "@/router";

@Component({
	components: {
		"generic-table": GenericTable
	}
})

export default class EventLinksTable extends Vue {
	@Prop() readonly eventLinks: PaginatedEventLinkInfo;
	@Prop() readonly isLoading: boolean;

	@Getter("getPermissions") permissions: UserPermissions;

	private readonly defaultPageSize: number = 5;

	private get columns(): TableHeader[] {
		return [
			{
				title: "Event ID",
				key: "eventId",
				order: 1,
				sortOrder: 1,
				sortOrderReversed: false,
				visible: true,
				useCustomCell: true,
				sortable: true,
				width: "80px",
			},
			{
				title: "Title",
				key: "eventTitle",
				order: 2,
				sortOrder: 2,
				sortOrderReversed: false,
				visible: true,
				sortable: true,
			},
			{
				title: "Linked At",
				key: "linkedAt",
				order: 3,
				sortOrder: 3,
				sortOrderReversed: false,
				visible: true,
				sortable: true,
			},
		]
	}

	private get eventLinksWithDateFormat(): EventLinkInfo[] {
		let mappedEventLinks = this.eventLinks.data.map(link => {
			return ({
				...link,
				linkedAt: link.linkedAt ? new Date(link.linkedAt).toLocaleString().toUpperCase() : ""
			})
		})

		return mappedEventLinks;
	}

	private get canEditEventLinkPermission(): boolean {
		return this.permissions.canEditEventLink;
	}

	private isEventLinkActive(eventLink: EventLinkInfo): boolean {
		return eventLink.isEventActive;
	}

	private emitDeleteEventLink(eventLink: EventLinkInfo): void {
		this.$emit("delete-link", eventLink);
	}

	private openEventReview(eventLink: EventLinkInfo): void {
		if (!eventLink.isEventActive) {
			return;
		}

		let path = `/eventsearch/${eventLink.eventId}`;

		const routeData = router.resolve({path,})

		window.open(routeData.href, path);
	}

	private searchFilterUpdated(paginatedSearchQueryParams: PaginatedSearchQueryParams): void {
		this.$emit("search-filter-updated", paginatedSearchQueryParams);
	}
}
